module.exports = __webpack_public_path__ + "static/media/3DPPA20.0b4b10f2.jpg";